import { ILocationClock } from 'src/common/interfaces'
import {
  ITribuneKlok,
  IVeildagVeilgroepTellingReport,
} from 'src/common/services/client'

import type { AuctionGroupCountReport } from '../types'

export const toComboBoxOption = (clk: ILocationClock): JSX.Element => (
  <option key={clk.clockNumber} value={clk.clockNumber}>
    {clk.clockName}
  </option>
)

type KarAantallen = {
  aantalKarren?: number
  aantalOntvangenKarren?: number
  aantalNogTeOntvangenKarren?: number
  aantalInNeerzetvolgordeKarren?: number
  aantalNietInNeerzetvolgordeKarren?: number
}

const toKarAantallen = (
  report: IVeildagVeilgroepTellingReport
): KarAantallen => ({
  aantalKarren: report.aantalKarren,
  aantalInNeerzetvolgordeKarren: report.aantalInNeerzetvolgordeKarren,
  aantalOntvangenKarren: report.aantalOntvangenKarren,
  aantalNietInNeerzetvolgordeKarren:
    report.aantalKarren - report.aantalOntvangenKarren,
  aantalNogTeOntvangenKarren: Math.max(
    report.aantalOntvangenKarren - report.aantalInNeerzetvolgordeKarren,
    0
  ),
})

export const toAuctionGroupCount = (
  report: IVeildagVeilgroepTellingReport
): AuctionGroupCountReport => {
  const karAantallen = toKarAantallen(report)
  return {
    auctionDate: report.veildatum,
    clockName: report.klokNaam,
    auctionGroupCode: report.veilgroepCode,
    auctionGroupDescription: report.veilgroepOmschrijving,
    locationCode: report.vestigingCode,
    trolleysDeclared: karAantallen.aantalKarren,
    trolleysReceived: karAantallen.aantalOntvangenKarren,
    trolleysToReceive: karAantallen.aantalNogTeOntvangenKarren,
    trolleysPlacedInOrder: karAantallen.aantalInNeerzetvolgordeKarren,
    trolleysNotPlacedInOrder: karAantallen.aantalNietInNeerzetvolgordeKarren,
  }
}

export const toLocationClock = (apiData: ITribuneKlok): ILocationClock => ({
  clockNumber: apiData.klokNummer,
  clockName: apiData.klokNaam,
  locationCode: apiData.vestigingCode,
})
